export const THEMES = [
  {
    id: "champagne",
    label: "Champagne",
    vars: {
      "--bg": "radial-gradient(120% 90% at 50% 0%, #f2e7d0 0%, #e2d1b2 48%, #c8b189 100%)",
      "--ink": "#40311c",
      "--muted": "#7d6743",
      "--gold-hi": "#f2dfae",
      "--gold": "#a87f2e",
      "--gold-lo": "#6f501a",
      "--line": "rgba(111,80,26,.45)",
      "--card": "rgba(255,251,240,.45)",
      "--btn-ink": "#fffaf0",
    },
  },
  {
    id: "marble",
    label: "Mármore Noir",
    vars: {
      "--bg": "radial-gradient(55% 40% at 88% 5%, rgba(212,175,55,.15), transparent 62%), radial-gradient(45% 35% at 5% 95%, rgba(212,175,55,.12), transparent 60%), linear-gradient(158deg, #1a1d1a 0%, #0c0e0c 52%, #050705 100%)",
      "--ink": "#f1e7cf",
      "--muted": "#b3a487",
      "--gold-hi": "#f9e7ae",
      "--gold": "#d4af37",
      "--gold-lo": "#8a6a1c",
      "--line": "rgba(212,175,55,.32)",
      "--card": "rgba(255,255,255,.04)",
      "--btn-ink": "#171204",
    },
  },
  {
    id: "bronze",
    label: "Bronze",
    vars: {
      "--bg": "radial-gradient(95% 65% at 50% -8%, #57300f 0%, #2a1505 52%, #0c0501 100%)",
      "--ink": "#f6e4c6",
      "--muted": "#c49a6a",
      "--gold-hi": "#ffdcaa",
      "--gold": "#d99a4e",
      "--gold-lo": "#8f5522",
      "--line": "rgba(217,154,78,.38)",
      "--card": "rgba(255,220,170,.05)",
      "--btn-ink": "#1c0e02",
    },
  },
  {
    id: "artdeco",
    label: "Art Déco",
    vars: {
      "--bg": "radial-gradient(70% 50% at 50% 0%, rgba(230,199,122,.09), transparent 60%), radial-gradient(50% 40% at 100% 100%, rgba(230,199,122,.06), transparent 65%), linear-gradient(180deg, #121211 0%, #090908 100%)",
      "--ink": "#f3ead2",
      "--muted": "#b8ab8a",
      "--gold-hi": "#fbebb5",
      "--gold": "#e0c273",
      "--gold-lo": "#93702a",
      "--line": "rgba(224,194,115,.34)",
      "--card": "rgba(255,255,255,.035)",
      "--btn-ink": "#161204",
    },
  },
  {
    id: "noir",
    label: "Noir Rosé",
    vars: {
      "--bg": "radial-gradient(110% 75% at 50% -12%, #37190c 0%, #170b06 55%, #070303 100%)",
      "--ink": "#f4e3cf",
      "--muted": "#bd9270",
      "--gold-hi": "#f8d2ab",
      "--gold": "#d18a56",
      "--gold-lo": "#8a4a2c",
      "--line": "rgba(209,138,86,.36)",
      "--card": "rgba(255,215,180,.045)",
      "--btn-ink": "#1d0d04",
    },
  },
];
